import {
    createElementVNode as _$ce,
} from 'intact';

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', this.get('children'), 0, 'k-colorpicker-drag k-colorpicker-text', {
        'ev-mousedown': this.drag.start
    });
};